import cn from 'classnames';
import { tail } from 'lodash';
import { observer } from 'mobx-react';
import React, { useState } from 'react';

import EngineStep from '@/comp/pages/EnginePage/Engine/Common/EngineStep/EngineStep';
import { useStores } from '@/hooks/use-stores';
import { EngineStepsEnum } from '@/store/Engine/constants';

import { ValidationMessagePopoverGlobalStyle } from './Common/styled';
import { EngineContainer } from './styled';

const stepsComponents = [
  props => <EngineStep step={EngineStepsEnum.CompressorGroups} {...props} />,
  props => <EngineStep step={EngineStepsEnum.SensorsConfiguration} {...props} />,
  props => <EngineStep step={EngineStepsEnum.MainRangesConfiguration} {...props} />,
  props => <EngineStep step={EngineStepsEnum.DefaultSetpointsConfiguration} {...props} />,
  props => <EngineStep step={EngineStepsEnum.StationConfiguration} {...props} />,
  props => <EngineStep step={EngineStepsEnum.CompressorParametersConfiguration} {...props} />,
];
const stepsArray = Array.from({ length: stepsComponents?.length }, (_, i) => i + 1);

interface EngineProps {
  setActiveTab;
  initialStepName?;
  hasTriedToSubmit?;
  setHasTriedToSubmit?;
}

const Engine = observer(({ setActiveTab, initialStepName, hasTriedToSubmit, setHasTriedToSubmit }: EngineProps) => {
  const { engineStore } = useStores();
  const initialStepNumber = Object.values(EngineStepsEnum).indexOf(initialStepName);
  const [selectedStep, setSelectedStep] = useState(initialStepNumber !== -1 ? initialStepNumber : 1);
  const StepComponent = stepsComponents[selectedStep];

  const renderStepIndicators = () =>
    !engineStore.hasFinishedWizard &&
    tail(stepsArray).map(item => (
      <div className="step-item" key={item}>
        <div className={cn('circle', selectedStep === item - 1 && 'selected')}>{item - 1}</div>
        <div className="horizontal-link" />
      </div>
    ));

  return (
    <EngineContainer $hasFinishedWizard={engineStore.hasFinishedWizard}>
      <ValidationMessagePopoverGlobalStyle />
      <div className="flex-row">
        <>
          <div className="steps" style={{ zIndex: '-1' }}>
            {renderStepIndicators()}
          </div>
          <div className="card">
            <StepComponent
              selectedStep={selectedStep}
              setSelectedStep={setSelectedStep}
              setActiveTab={setActiveTab}
              hasTriedToSubmit={hasTriedToSubmit}
              setHasTriedToSubmit={setHasTriedToSubmit}
            />
          </div>
        </>
      </div>
    </EngineContainer>
  );
});

export default Engine;
